// 集中管理请求地址，所有的接口地址：

/**
 * title: 接口描述
 * uri: 请求地址
 * method: 请求方式
 * const params = {
    uriCode: 'TEST01',
    // restful
    bindVars: [{
        key: "id",
        value: 'xxx',
    }, {
        key: "type",
        value: 'xxx'
    }]
  }
 */

const API = {
  API001: { title: '登录', uri: '/v1/pub/competition_front/login', method: 'post' },
  API002: { title: '注册', uri: '/v1/pub/competition_front/register', method: 'post' },
  API003: { title: '实名认证', uri: '/v1/pub/competition_front/auth', method: 'post' },
  API004: { title: '报名', uri: '/api/v1/competition_front/apply', method: 'post' },
  API005: { title: '获取验证码', uri: '/v1/pub/getCaptcha' },
  // 比赛信息管理
  API006: { title: '获取比赛信息列表', uri: '/v1/pub/competition_front/list' },
  API007: { title: '获取公告列表', uri: '/v1/pub/competition_front/placard/list' },
  API008: { title: '获取比赛详情', uri: '/v1/pub/competition_front/detail' },
  // 比赛报名
  API009: { title: '报名', uri: '/v1/pub/competition_front/apply', method: 'post' },
  API010: { title: '获取报名结果', uri: '/v1/pub/competition_front/applyResult' },
  API011: { title: '获取比赛结果', uri: '/v1/pub/competition_front/result' },
  API012: { title: '获取用户认证信息', uri: '/v1/pub/competition_front/verified_info' },
  API013: { title: '取消报名', uri: '/v1/pub/competition_front/apply_revoke' },
  API014: { title: '进入比赛token获取', uri: '/v1/pub/competition_front/enter_comp' }
}

export default API
